import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";

import { CommentRecord, CreateCommentRequest } from "../CommentRecord";

import * as Comments from "./getQueryKey";

/**
 * Hook for creating a new comment.
 * Automatically invalidates comment queries on success.
 */
export function useCreateComment() {
  const { commentService } = useDomainServices();
  const { currentOrganization } = useAuth();
  const queryClient = useQueryClient();

  return useMutation<CommentRecord, Error, CreateCommentRequest>({
    mutationFn: (request: CreateCommentRequest) => {
      if (!currentOrganization?.org_id) {
        throw new Error("CurrentOrganization is not set");
      }

      return commentService.createComment(request, {
        orgId: currentOrganization.org_id,
      });
    },
    onSuccess: () => {
      // Invalidate all comment queries to refetch with the new comment
      void queryClient.invalidateQueries({
        queryKey: Comments.getQueryKey(),
      });
    },
  });
}
